import { useEffect, useRef } from 'react';

interface ReservationSuccessAnimationProps {
  onComplete?: () => void;
}

export const ReservationSuccessAnimation = ({ onComplete }: ReservationSuccessAnimationProps) => {
  const castleRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // Defer confetti animation to avoid blocking critical render path
    const deferredConfetti = () => {
      // Dynamic import to avoid blocking the main bundle
      import('canvas-confetti').then((confetti) => {
        const duration = 3000;
        const end = Date.now() + duration;

        const frame = () => {
          confetti.default({
            particleCount: 2,
            angle: 60,
            spread: 55,
            origin: { x: 0 },
            colors: ['#ffd700', '#ff6b6b', '#4ecdc4', '#45b7d1', '#96ceb4', '#ffeaa7']
          });
          confetti.default({
            particleCount: 2,
            angle: 120,
            spread: 55,
            origin: { x: 1 },
            colors: ['#ffd700', '#ff6b6b', '#4ecdc4', '#45b7d1', '#96ceb4', '#ffeaa7']
          });

          if (Date.now() < end) {
            requestAnimationFrame(frame);
          }
        };
        frame();
      });
    };

    // Use setTimeout to defer confetti after critical rendering
    const confettiTimeout = setTimeout(deferredConfetti, 100);

    // Castle animation using CSS classes instead of direct style manipulation
    const animationTimeout = setTimeout(() => {
      if (castleRef.current) {
        castleRef.current.classList.add('animate-castle-enter');
      }
    }, 500);

    // Call onComplete after animation
    const completeTimeout = setTimeout(() => {
      onComplete?.();
    }, 4000);

    return () => {
      clearTimeout(confettiTimeout);
      clearTimeout(animationTimeout);
      clearTimeout(completeTimeout);
    };
  }, [onComplete]);

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[9999] p-4">
      <div className="bg-white rounded-2xl p-8 text-center max-w-md w-full shadow-2xl animate-scale-in">
        <div 
          ref={castleRef} 
          className="text-8xl mb-6 scale-[0.3] opacity-0 transition-all duration-[1500ms] ease-[cubic-bezier(0.68,-0.55,0.265,1.55)]"
        >
          🏰
        </div>
        <h2 className="text-2xl font-bold text-primary mb-4 animate-pulse">
          Demande envoyée !
        </h2>
        <p className="text-gray-600">
          Nous avons bien reçu votre demande de réservation. 
          Vous recevrez une confirmation par email très bientôt !
        </p>
      </div>
    </div>
  );
};